import React, { FunctionComponent } from 'react'
import { EmptyPlaceHolder } from '../../../components/shared/EmptyPlaceHolder'
import { MailEmptyPageProps } from './MailEmptyPage.model'

export const MailEmptyPage: FunctionComponent<MailEmptyPageProps> = () => {
  return <EmptyPlaceHolder />
}
